import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EGoalTypes } from '../../../../shared/models/eop_types.enum';
import { FunctionService } from '../../../../shared/services/function.service';
import { UserDataService } from '../../../../shared/services/userData.service';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'new-function',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    NoEmojiDirective
  ],
  templateUrl: './new-function.component.html',
  styleUrl: './new-function.component.css'
})
export class NewFunctionComponent implements OnInit {
  icons = Icons;
  functionForm: FormGroup = new FormGroup({});

  currentBuildingId: string | null = null;
  goalType = EGoalTypes;

  loading: boolean = false;

  @Input() functionName: string = '';
  @Output() onSave = new EventEmitter<any>;
  @Output() onClose = new EventEmitter<void>;

  constructor(
    private userDataService: UserDataService,
    private functionService: FunctionService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['functionName'] && this.functionName) {
      this.initializeForm(); 
    }
  }

  private initializeForm(): void {
    this.functionForm = new FormGroup({
      function_name: new FormControl(this.functionName, Validators.required),
      goal_before_description: new FormControl('', Validators.required),
      goal_before_objective: new FormControl('', Validators.required),
      goal_during_description: new FormControl('', Validators.required),
      goal_during_objective: new FormControl('', Validators.required),
      goal_after_description: new FormControl('', Validators.required),
      goal_after_objective: new FormControl('', Validators.required)
    });
  }

  onSubmit(): void {
    if (this.functionForm.valid && this.currentBuildingId) {
      // Structure the final object as per the desired format
      const formValue = this.functionForm.value;
      const goals = [
        {
          goal_type: this.goalType['Before'],
          goal_description: formValue.goal_before_description,
          objective: formValue.goal_before_objective
        },
        {
          goal_type: this.goalType['During'],
          goal_description: formValue.goal_during_description,
          objective: formValue.goal_during_objective
        },
        {
          goal_type: this.goalType['After'],
          goal_description: formValue.goal_after_description,
          objective: formValue.goal_after_objective
        }
      ];
      const finalData = {
        function_name: formValue.function_name,
        goals: goals
      };
      
      this.loading = true;
      this.functionService.createNewThreat(this.currentBuildingId, finalData).subscribe({
        next: (response) => {
          this.loading = false;
          if (!response.has_error) {
            this.onSave.emit({ type: 'success', message: 'This occurred after creating new function goals and objectives.' });
          }
          console.log(response);
        },
        error: (error) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: error.message });
        }
      })
      
    }
  }

  closeModal(): void {
    this.onClose.emit();
  }
}
